export const Roles = {
	// Platform owner. God-mode: listed alongside every module below, which mirrors the
	// backend's @Restrict({@Group("root"), @Group(<module>)}) -- Deadbolt treats those as OR.
	ROOT: 'root',

	// Portal modules (Ciclo 7) -- capacidade. One Deadbolt group per module.
	CONSOLE: 'console',
	ADMIN: 'admin',
	STUDIO: 'studio',
	PANEL: 'panel',
}
